import React from 'react';
import C18Button00 from './C18Button00'
import { cl } from '../utils/utils';

class C18HydroRootStatusBar extends React.Component{
  constructor(props) {
    super(props);
    this.state={cancelLoading:false}
    this.timer=null
    this._isMounted=false
  }

  componentDidMount(){
    this._isMounted=true
    if(this.props.endTime){
      this.timer=setInterval(()=>{this.forceUpdate()},60000)
    }
  }

  componentDidUpdate(prevProps){
    if(prevProps.endTime!==this.props.endTime){
      if(this.timer){clearInterval(this.timer)}
      if(this.props.endTime){
        this.timer=setInterval(()=>{this.forceUpdate()},60000)
      }
    }
  }

  componentWillUnmount(){
    this._isMounted=false
    if(this.timer){clearInterval(this.timer)}
  }

  handleCancelClick=(ev)=>{
    let fn=this.props.onCancel
    if(!fn||this.state.cancelLoading){return}
    this.setState({cancelLoading:true})
    Promise.resolve(fn(ev)).finally(()=>{
      if(this._isMounted){this.setState({cancelLoading:false})}
    })
  }

  getCountdown=()=>{
    let endT=this.props.endTime
    if(!endT){return null}
    let now=Math.floor(Date.now()/1000)
    let rem=endT-now
    if(rem<=0){return null}
    let d=Math.floor(rem/86400)
    let h=Math.floor((rem%86400)/3600)
    let m=Math.floor((rem%3600)/60)
    return {d,h,m}
  }

  render(){
    // cl("C18HydroRootStatusBar render", {props:this.props, state:this.state})
    let pr=this.props
    let cd=this.getCountdown()
    return(
      <div className={pr.className||"water-budget-status-bar"}>
        <span className="water-budget-status-label">{pr.label}</span>
        {pr.detail &&(
          <span className="water-budget-status-label">{pr.detail}</span>
        )}
        {cd &&(
          <div className="wb-countdown wb-cd-box">
            <span className=""><span className="wb-cd-val"> - {cd.d}</span>d</span>
            <span className="wb-cd-sep">:</span>
            <span className=""><span className="wb-cd-val">{String(cd.h).padStart(2,"0")}</span><span className="wb-cd-unit">h</span></span>
            <span className="wb-cd-sep">:</span>
            <span className=""><span className="wb-cd-val">{String(cd.m).padStart(2,"0")}</span><span className="wb-cd-unit">m</span></span>
          </div>
        )}
        {pr.onCancel &&(
          <C18Button00 type="button" className="water-budget-cancel-btn"
            onClick={this.handleCancelClick}
            disabled={this.state.cancelLoading}
            aria-busy={this.state.cancelLoading}>
            {this.state.cancelLoading &&(
              <img src="/img/spinner.gif" alt=""
                style={{height:12,width:12,verticalAlign:"middle",marginRight:6}}/>
            )}
            {pr.cancelText||"Cancel"}
          </C18Button00>
        )}
      </div>
    )
  }
}

export default C18HydroRootStatusBar;
